import React, { useState, useEffect } from 'react';
// import ToggleSwitch from '../components/ToggleSwitch';
import stylesCat from '../styles/Category.module.css';
import styles from '../styles/PlaceholderPage.module.css';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { getData, postData, putData, postFormData, deleteData } from '../ServerRequest.js';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [productId, setProductId] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [showSecondForm, setShowSecondForm] = useState(false);
  const [collectionOptions, setCollectionOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [secondForm, setSecondForm] = useState({
    details: [
      { title: "Gross Weight", description: "" },
      { title: "Net Weight", description: "" },
      { title: "Product Dimensions", description: "" },
      { title: "Package Dimensions", description: "" },
      { title: "Contents", description: "" }
    ],
    images: [null], // Initialize with one empty image slot
    previews: [null] // For image preview URLs
  });
  const [form, setForm] = useState({
    name: '',
    image: '',
    price: '',
    description: '',
    offerPrice: '',
    category: '',
    collection: '',
    discount: '',
    stock: '',
    purchase_date: '',
    images: [], // <-- add images array for multiple uploads
  });
  const [imageFields, setImageFields] = useState([0]); // for rendering image upload fields
  const [editIndex, setEditIndex] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [carouselIndexes, setCarouselIndexes] = useState({});
  const company_id = localStorage.getItem('company') || 1; // Default to 1 if not set
  // Auto-scroll carousel for each product
  useEffect(() => {
    if (!products || products.length === 0) return;

    const interval = setInterval(() => {
      setCarouselIndexes(prevIndexes => {
        const newIndexes = { ...prevIndexes };
        products.forEach((product, idx) => {
          const id = product.product_id || idx;
          const imagesLength = product.images ? product.images.length : 0;
          if (imagesLength > 0) {
            newIndexes[id] = (prevIndexes[id] || 0) + 1;
            if (newIndexes[id] >= imagesLength) {
              newIndexes[id] = 0;
            }
          }
        });
        return newIndexes;
      });
    }, 2000); // Change image every 2 seconds

    return () => clearInterval(interval);
  }, [products]);

  // Fetch products from API using ServerRequest
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Products API
        const productsRes = await getData(`/api/product/products/?company_id=${company_id}`);
        console.log('Products API Response:', productsRes);
        if (productsRes.data?.data) {
          setProducts(productsRes.data.data.map(p => ({
            ...p,
            newArrival: p.new_arrival === undefined ? true : Boolean(p.new_arrival)
          })));
        }

        // Collections API
        const collectionsRes = await getData(`/api/product/collections/?company_id=${company_id}`);
        console.log('Collections API Response:', collectionsRes);
        if (collectionsRes.data?.collections) {
          setCollectionOptions(collectionsRes.data.collections);
        }

        // Categories API
        const categoriesRes = await getData(`/api/product/categories/?company_id=${company_id}`);
        console.log('Categories API Response:', categoriesRes);
        if (categoriesRes.data?.categories) {
          setCategoryOptions(categoriesRes.data.categories);
        }

      } catch (err) {
        console.error('API Error:', err);
        setError('Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Add product using ServerRequest
  const handleSecondFormSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Submit all details
      for (const detail of secondForm.details) {
        const additionalDetailReq = {
          title: detail.title,
          description: detail.description
        };
        const res = await postData(`/api/product/products/${productId}/additional-details/`, additionalDetailReq);
        if (res.code === 201 || res.code === 200) {
          // Optionally show a success message
        }
      }
      // Handle image uploads
      for (const value of secondForm.images) {
        if (value) {
          const formData = new FormData();
          formData.append('image', value);
          const res = await postFormData(`/api/product/products/${productId}/images/`, formData);
          if (res.code === 201 || res.code === 200) {
            // Optionally show a success message
          }
        }
      }
      // Refresh product list so new images appear immediately
      const refreshed = await getData(`/api/product/products/?company_id=${company_id}`);
      if (refreshed.data?.data) {
        setProducts(refreshed.data.data.map(p => ({
          ...p,
          newArrival: Boolean(p.new_arrival)
        })));
      }
      // Reset forms and close them
      setSecondForm({
        details: [
          { title: "Gross Weight", description: "" },
          { title: "Net Weight", description: "" },
          { title: "Product Dimensions", description: "" },
          { title: "Package Dimensions", description: "" },
          { title: "Contents", description: "" }
        ],
        images: [null]
      });
      setShowSecondForm(false);
      setShowForm(false);
      setLoading(false);
    } catch (err) {
      setError('Failed to submit second form');
      setLoading(false);
    }
  };

  const handleProductSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    // Get company from localStorage (active session) and ensure it's a number
    let company = localStorage.getItem('company');
    if (!company || isNaN(Number(company))) {
      setError('No valid company id found in session. Please log in again.');
      setLoading(false);
      return;
    }
    company = Number(company); // Ensure company is a number
    // --- IMAGE LOGIC COMMENTED OUT ---
    // const convertToBase64 = (file) => {
    //   return new Promise((resolve, reject) => {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onload = () => resolve(reader.result);
    //     reader.onerror = (error) => reject(error);
    //   });
    // };
    // if (form.image && typeof form.image !== 'string') {
    //   reqData.image_url = await convertToBase64(form.image);
    // }
    // --- END IMAGE LOGIC ---
    const reqData = {
      name: form.name || '',
      description: form.description || '',
      category: form.category || '',
      collection: form.collection || '',
      product_name: form.product_name || '',
      brand_name: form.brand_name || '',
      price: form.price ? Number(form.price) : 0,
      discount: form.discount ? Number(form.discount) : 0,
      stock: form.stock ? Number(form.stock) : 0,
      tax: form.tax ? Number(form.tax) : 0,
      current_quantity: form.current_quantity ? Number(form.current_quantity) : 0,
      remarks: form.remarks || '',
      // status: 1,
      created_by_id: 'admin',
      updated_by_id: 'admin',
      company: company, // Always a number
      new_arrival: true // <-- Always set new product as New Arrival
      // image_url: form.image || '', // IMAGE LOGIC COMMENTED OUT
    };
    try {
      const res = await postData('/api/product/products/', reqData);
      if (res.code === 201 || res.code === 200) {
        // Only show the second form after successful API response
        setShowSecondForm(true);
        setShowForm(false);
        console.log('Product added successfully with id:', res.data?.data.product_id);
        setProductId(res.data?.data.id || 0); // Set productId for second form
        // Don't clear the form data yet, as we might need it for the second form

        // Refresh product list with correct company
        const refreshed = await getData(`/api/product/products/?company_id=${company}`);
        setProducts(refreshed.data?.data || []);
      } else {
        setError(res.message || 'Failed to add product');
      }
    } catch (err) {
      setError('Failed to add product');
    } finally {
      setLoading(false);
    }
  };

  const handleAddProduct = (e) => {
    e.preventDefault();
    if (editIndex !== null) {
      // Edit product
      const updated = [...products];
      updated[editIndex] = {
        product_id: form.product_id || `Product ${editIndex + 1}`,
        name: form.name || `Product ${editIndex + 1}`,
        image: form.image || 'https://via.placeholder.com/150',
        price: form.price ? Number(form.price) : 0,
        description: form.description || 'No description.',
        offerPrice: form.offerPrice ? Number(form.offerPrice) : 0,
      };
      setProducts(updated);
      setEditIndex(null);
    } else {
      // Add new product
      setProducts([
        ...products,
        {
          product_id: form.product_id || `Product ${products.length + 1}`,
          name: form.name || `Product ${products.length + 1}`,
          image: form.image || 'https://via.placeholder.com/150',
          price: form.price ? Number(form.price) : 0,
          description: form.description || 'No description.',
          offerPrice: form.offerPrice ? Number(form.offerPrice) : 0,
        },
      ]);
    }
    setForm({ product_id: '', name: '', image: '', price: '', description: '', offerPrice: '' });
    setShowForm(false);
  };

  const handleEdit = (idx) => {
    setEditIndex(idx);
    setForm(products[idx]);
    setShowForm(true);
  };

  const handleRemove = async (idx) => {
    const product = products[idx];
    const productId = product.product_id || product.id;
    if (!productId) {
      setError('No product id found for deletion');
      return;
    }
    try {
      const res = await deleteData(`/api/product/products/${productId}/`);
      if (res.code === 200 || res.code === 204) {
        setProducts(products.filter((_, i) => i !== idx));
        if (editIndex === idx) {
          setShowForm(false);
          setEditIndex(null);
        }
      } else {
        setError(res.message || 'Failed to delete product');
      }
    } catch (err) {
      setError('Failed to delete product');
    }
  };

  const handlePrevImage = (productId, imagesLength) => {
    setCarouselIndexes(prev => ({
      ...prev,
      [productId]: prev[productId] > 0 ? prev[productId] - 1 : imagesLength - 1
    }));
  };

  const handleNextImage = (productId, imagesLength) => {
    setCarouselIndexes(prev => ({
      ...prev,
      [productId]: prev[productId] < imagesLength - 1 ? prev[productId] + 1 : 0
    }));
  };

  return (
    // <div style={{ gridColumn: '1 / 4' }}>
    //   <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Product Images (up to 6)</label>
    //   < style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '8px' }}>
    //     {imageFields.map((fieldIdx, idx) => (
    //       <div key={fieldIdx} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    //         <input
    //           type="file"
    //           accept="image/*"
    //           onChange={e => {
    //             const files = [...form.images];
    //             files[idx] = e.target.files[0];
    //             setForm({ ...form, images: files });
    //           }}
    //         />
    //         {imageFields.length > 1 && (
    //           <button
    //             type="button"
    //             onClick={() => {
    //               setImageFields(fields => fields.filter((_, i) => i !== idx));
    //               setForm(f => ({ ...f, images: f.images.filter((_, i) => i !== idx) }));
    //             }}
    //             style={{ padding: '2px 8px' }}
    //           >Remove</button>
    //         )}
    //       </div>
    //     ))}
    //   </div>
    //   <button
    //     type="button"
    //     onClick={() => setImageFields(fields => [...fields, Date.now()])}
    //     style={{ marginTop: 4,  }}
    //     disabled={imageFields.length >= 6}
    //   >Add Image</button>
    // </div>
    <div className={styles.placeholderContainer}>
      {/* Only show header, add button, and product list if not adding or editing a product */}
      {!showForm && !showSecondForm && (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
            <h2>Products ({products.length})</h2>
            <button className={styles.addButton} onClick={() => { setShowForm(true); setShowSecondForm(false); setEditIndex(null); setForm({ name: '', image: '', price: '', description: '', offerPrice: '', category: '', collection: '', discount: '', stock: '', purchase_date: '', images: [] }); setImageFields([0]); }}>Add Product</button>
          </div>
        </>
      )}

      {/* Show only the add product form when showForm is true */}
      {showForm && (
        <form
          className={styles.productForm}
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '20px',
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 0px 0px rgba(0, 0, 0, 0)',
            padding: '24px',
            margin: '20px ,20px',
            width: '100%',
          }}
          onSubmit={handleProductSubmit}
        >
          {/* ...existing form fields... */}
          <div style={{ gridColumn: '1 / 2' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Name</label>
            <input type="text" className={styles.input} style={{ width: '100%' }} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Category</label>
            <select
              className={styles.input}
              style={{ width: '100%' }}
              value={form.category}
              onChange={e => setForm({ ...form, category: e.target.value })}
              required
            >
              <option value="">Select a Category</option>
              {categoryOptions.map(option => (
                <option key={option.id} value={option.id}>
                  {option.category}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Collection</label>
            <select
              className={styles.input}
              style={{ width: '100%' }}
              value={form.collection}
              onChange={e => setForm({ ...form, collection: e.target.value })}
              required
            >
              <option value="">Select a collection</option>
              {collectionOptions.map(option => (
                <option key={option.id} value={option.id}>
                  {option.collection}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Price</label>
            <input type="number" className={styles.input} style={{ width: '100%' }} value={form.price} onChange={e => setForm({ ...form, price: e.target.value })} required />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Discount Price</label>
            <input type="number" className={styles.input} style={{ width: '100%' }} value={form.discount} onChange={e => setForm({ ...form, discount: e.target.value })} />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Brand Name</label>
            <input type="text" className={styles.input} style={{ width: '100%' }} value={form.brand_name} onChange={e => setForm({ ...form, brand_name: e.target.value })} />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Product Name</label>
            <input type="text" className={styles.input} style={{ width: '100%' }} value={form.product_name} onChange={e => setForm({ ...form, product_name: e.target.value })} />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Tax</label>
            <input type="number" className={styles.input} style={{ width: '100%' }} value={form.tax} onChange={e => setForm({ ...form, tax: e.target.value })} />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Current quantity</label>
            <input type="number" className={styles.input} style={{ width: '100%' }} value={form.current_quantity} onChange={e => setForm({ ...form, current_quantity: e.target.value })} />
          </div>
          <div style={{ gridColumn: '1 / 2' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Description</label>
            <textarea className={styles.input} style={{ width: '100%', minHeight: '60px' }} value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Remarks</label>
            <textarea className={styles.input} style={{ width: '100%', minHeight: '60px' }} value={form.remarks} onChange={e => setForm({ ...form, remarks: e.target.value })} />
          </div>
          {/* image upload fields and buttons if needed */}
          <div style={{ gridColumn: '1 / -1', display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '12px' }}>
            <button className={styles.addButton} type="submit">Next</button>
            <button className={styles.cancelButton} type="button" onClick={() => setShowForm(false)}>Cancel</button>
          </div>
        </form>
      )}

      {/* Show the second form if needed (unchanged) */}
      {showSecondForm && (
        // ...existing code for second form...
        <form
          className={styles.productForm}
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '20px',
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 0px 0px rgba(0,0,0,0.0)',
            padding: '24px',
            margin: '-50px 0px',
            width: '100%',
          }}
          onSubmit={handleSecondFormSubmit}
        >
          {/* ...existing second form fields... */}
          <h1 style={{ gridColumn: '1 / -1', fontWeight: 500, marginBottom: '20px' }}>Additional Details</h1>
          {secondForm.details.map((detail, idx) => (
            <div key={idx} style={{ gridColumn: '1 / -1', display: 'flex', gap: '10px', alignItems: 'center' }}>
              <input
                type="text"
                className={styles.input}
                style={{ flex: 1, border: 'none' }}
                placeholder="Title"
                value={detail.title}
                onChange={e => {
                  const newDetails = [...secondForm.details];
                  newDetails[idx].title = e.target.value;
                  setSecondForm({ ...secondForm, details: newDetails });
                }}
                required
              />
              <input
                type="text"
                className={styles.input}
                style={{ flex: 2 }}
                placeholder="Description"
                value={detail.description}
                onChange={e => {
                  const newDetails = [...secondForm.details];
                  newDetails[idx].description = e.target.value;
                  setSecondForm({ ...secondForm, details: newDetails });
                }}
                required
              />
              {secondForm.details.length > 1 && (
                <button
                  type="button"
                  className={styles.removeButton}
                  onClick={() => {
                    const newDetails = secondForm.details.filter((_, i) => i !== idx);
                    setSecondForm({ ...secondForm, details: newDetails });
                  }}
                  style={{ padding: '4px 8px' }}
                >
                  Remove
                </button>
              )}
            </div>
          ))}
          <button
            type="button"
            className={styles.addButton}
            onClick={() => setSecondForm({ ...secondForm, details: [...secondForm.details, { title: '', description: '' }] })}
            style={{ gridColumn: '1 / -1', marginTop: '10px', width: 'auto', padding: '4px 12px' }}
          >
            Add More Fields
          </button>
          <div style={{ gridColumn: '1 / -1', marginTop: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Images</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {secondForm.images.map((_, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={e => {
                      const file = e.target.files[0];
                      const newImages = [...secondForm.images];
                      newImages[index] = file;
                      // Set preview URL for this image
                      const newPreviews = [...(secondForm.previews || [])];
                      newPreviews[index] = file ? URL.createObjectURL(file) : null;
                      setSecondForm({ ...secondForm, images: newImages, previews: newPreviews });
                    }}
                    className={styles.input}
                    style={{ flex: 1 }}
                  />
                  {secondForm.previews && secondForm.previews[index] && (
                    <img
                      src={secondForm.previews[index]}
                      alt="Preview"
                      style={{ marginTop: '1rem', width: '100px', borderRadius: '8px' }}
                    />
                  )}
                  {secondForm.images.length > 1 && (
                    <button
                      type="button"
                      className={styles.removeButton}
                      onClick={() => {
                        const newImages = secondForm.images.filter((_, i) => i !== index);
                        const newPreviews = (secondForm.previews || []).filter((_, i) => i !== index);
                        setSecondForm({ ...secondForm, images: newImages, previews: newPreviews });
                      }}
                      style={{ padding: '4px 8px' }}
                    >
                      Remove
                    </button>
                  )}
                </div>
              ))}
            </div>
            <button
              type="button"
              className={styles.addButton}
              onClick={() => {
                setSecondForm({
                  ...secondForm,
                  images: [...secondForm.images, null]
                });
              }}
              style={{ marginTop: '1px', width: 'auto', padding: '7px 12px', marginLeft: '30px' }}
              disabled={secondForm.images.length >= 6}
            >
              Add More Images
            </button>
          </div>
          {secondForm.images.length >= 6 && (
            <p style={{ color: 'red', fontSize: '0.9em', marginTop: '4px', padding: '0px 140px' }}>
              Maximum 6 images are allowed
            </p>
          )}

          {/* Instruction Section - matches Additional Details structure */}
          <h3 style={{ gridColumn: '1 / -1', fontWeight: 500, marginBottom: '20px' }}>Instruction:</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '20px', rowGap: '30px', marginBottom: '10px', alignItems: 'center' }}>
            <div style={{ display: 'contents' }}>
              <label style={{ fontWeight: 500 }}>First Burn</label>
              <input
                type="text"
                className={styles.input}
                placeholder="Description"
                value={secondForm.firstBurn || ''}
                onChange={e => setSecondForm({ ...secondForm, firstBurn: e.target.value })}
              />
            </div>
            <div style={{ display: 'contents' }}>
              <label style={{ fontWeight: 500 }}>Relighting</label>
              <input
                type="text"
                className={styles.input}
                placeholder="Description"
                value={secondForm.relighting || ''}
                onChange={e => setSecondForm({ ...secondForm, relighting: e.target.value })}
              />
            </div>
            <div style={{ display: 'contents' }}>
              <label style={{ fontWeight: 500 }}>Safety</label>
              <input
                type="text"
                className={styles.input}
                placeholder="Description"
                value={secondForm.safety || ''}
                onChange={e => setSecondForm({ ...secondForm, safety: e.target.value })}
              />
            </div>
          </div>

          <div style={{ gridColumn: '1 / -1', display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '12px' }}>
            <button className={styles.addButton} type="submit">Submit</button>
            <button
              className={styles.cancelButton}
              type="button"
              onClick={() => {
                setShowSecondForm(false);
                setSecondForm({
                  details: [
                    { title: "Gross Weight", description: "" },
                    { title: "Net Weight", description: "" },
                    { title: "Product Dimensions", description: "" },
                    { title: "Package Dimensions", description: "" },
                    { title: "Contents", description: "" }
                  ],
                  images: [null],
                  firstBurn: '',
                  relighting: '',
                  safety: ''
                });
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      )}

      {/* Only show product list if not adding or editing a product */}
      {!showForm && !showSecondForm && (
        <div className={styles.productList}>
          {loading ? (
            <div className={styles.spinnerWrapper}>
              <div className={styles.spinner}></div>
              <div className={styles.spinnerText}>Loading products...</div>
            </div>
          ) : error ? (
            <div style={{ color: 'red' }}>{error}</div>
          ) : products.length === 0 ? (
            <div>No products found.</div>
          ) : (
            products.map((product, idx) => (
              <div key={product.product_id || idx} className={styles.productCard}>
                {product.images && product.images.length > 0 ? (
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    <button
                      onClick={() => handlePrevImage(product.product_id || idx, product.images.length)}
                      style={{ marginRight: 8 }}
                      aria-label="Previous image"
                    >
                      {'<'}
                    </button>
                    <img
                      src={
                        product.images[carouselIndexes[product.product_id || idx] || 0] &&
                          product.images[carouselIndexes[product.product_id || idx] || 0].display_url
                          ? product.images[carouselIndexes[product.product_id || idx] || 0].display_url
                          : 'https://via.placeholder.com/150'
                      }
                      alt={product.name}
                      className={styles.productImage}
                      style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 8 }}
                    />
                    <button
                      onClick={() => handleNextImage(product.product_id || idx, product.images.length)}
                      style={{ marginLeft: 8 }}
                      aria-label="Next image"
                    >
                      {'>'}
                    </button>
                  </div>
                ) : (
                  <img
                    src="https://via.placeholder.com/150"
                    alt={product.name}
                    className={styles.productImage}
                    style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 8 }}
                  />
                )}
                {console.log('PRODUCT:', product)}
                <h3>{product.name}</h3>
                <p style={{ wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{product.description}</p>
                <p>
                  <span className={styles.originalPrice}>₹{product.price}</span>{' '}
                  <span className={styles.offerPrice}>₹{product.discount || product.offerPrice}</span>
                </p>
                <div><b>Category:</b> {product.category}</div>
                <div><b>Collection:</b> {product.collection}</div>
                <div><b>Stock:</b> {product.stock}</div>
                <div className={stylesCat.toggleWrapper} style={{ margin: '8px 0' }}>
                  <span style={{ fontWeight: 700, color: '#111414fc', marginRight: '0.5rem' }}>New Arrival</span>
                  <label className={stylesCat.switch}>
                    <input
                      type="checkbox"
                      checked={!!product.newArrival}
                      onChange={async () => {
                        const newValue = !product.newArrival;
                        const prodId = product.product_id || product.id; // <-- Fix here
                        if (!prodId) {
                          alert('Product ID not found');
                          return;
                        }
                        try {
                          const res = await putData(
                            `/api/product/products/${prodId}/new-arrival/`,
                            { new_arrival: newValue }
                          );
                          if (res.code === 200 || res.code === 201) {
                            setProducts(prev =>
                              prev.map((p, i) =>
                                i === idx ? { ...p, newArrival: newValue } : p
                              )
                            );
                          } else {
                            alert(res.message || 'Failed to update New Arrival status');
                          }
                        } catch (err) {
                          alert('Failed to update New Arrival status');
                        }
                      }}
                    />
                    <span className={stylesCat.slider}></span>
                  </label>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
                  <button className={styles.editButton} onClick={() => handleEdit(idx)}>Edit</button>
                  <button className={styles.removeButton} onClick={() => handleRemove(idx)}>Remove</button>
                  <button className={styles.addButton} style={{ minWidth: 80 }} onClick={() => setSelectedProduct(product)}>Details</button>
                </div>
              </div>
            ))
          )}
        </div>
      )}
      {selectedProduct && (
        <Modal open={!!selectedProduct} onClose={() => setSelectedProduct(null)}>
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            minWidth: 350,
            maxWidth: 500
          }}>
            <h2>Product Details</h2>
            <img src={selectedProduct.image} alt={selectedProduct.name} style={{ width: '100%', maxHeight: 200, objectFit: 'cover', borderRadius: 8, marginBottom: 16 }} />
            <div><b>ID:</b> {selectedProduct.product_id}</div>
            <div><b>Name:</b> {selectedProduct.name}</div>
            <div><b>Description:</b> {selectedProduct.description}</div>
            <div><b>Price:</b> ₹{selectedProduct.price}</div>
            <div><b>Offer Price:</b> ₹{selectedProduct.offerPrice}</div>
            <button className={styles.addButton} style={{ marginTop: 18 }} onClick={() => setSelectedProduct(null)}>Close</button>
          </Box>
        </Modal>
      )}
    </div>
  );
};

export default Products;
